<template>
    <div class="select-profile-wrap">
        <h1 class="select-title">{{ $t('entrance.select_profile') }}</h1>

        <v-row dense>
            <v-col v-for="option in profileOptions" :key="option.value" :cols="option.wide ? 12 : 6">
                <button
                    type="button"
                    :class="['rol-card', { 'rol-card--wide': option.wide, 'rol-card--selected': profile === option.value }]"
                    @click="profile = option.value"
                >
                    <v-icon class="rol-icon" :color="profile === option.value ? 'white' : 'secondary'" size="32">
                        {{ option.icon }}
                    </v-icon>
                    <span class="rol-card-label">{{ option.name }}</span>
                </button>
            </v-col>
        </v-row>

        <v-btn @click="showConfirmSelect" color="primary" depressed block large
               class="black--text text-none font-weight-bold mt-6"
               :disabled="!profile" :loading="loadingSelect">
            {{ $t('common.continue') }}
        </v-btn>

        <logout-button outlined color="txtSecondary" large block class="mt-3"/>

        <kimsa-confirm
            ref="confirm"
            :title="$t('entrance.confirm_profile_selection_title')"
            show-cancel
            :cancel-label="$t('common.no')"
            :confirm-label="$t('common.yes_continue')"
            @confirm="onSelected"
        >
            <template #content>
                <i18n path="entrance.confirm_profile_selection_body" tag="p" class="confirm-role-text">
                    <template #profile>
                        <strong class="confirm-role-name">{{ selectedName }}</strong>
                    </template>
                </i18n>
            </template>
        </kimsa-confirm>
    </div>
</template>

<script>

import {db} from '@/utils/Firebase'
import LogoutButton from "@/components/common/inputs/LogoutButton";
import {mapActions} from "vuex";
import KimsaConfirm from '../common/KimsaConfirm.vue';

export default {
    components: {
        LogoutButton,
        KimsaConfirm
    },
    data(vm) {
        return {
            profile: null,
            loadingSelect: false,
            profileOptions: [
                {name: vm.$tc('student.student', 1), value: 'student', icon: '$account_circle'},
                {name: vm.$tc('coach.coach', 1), value: 'coach', icon: '$training'},
                {name: vm.$t('company.company'), value: 'company', icon: '$company', wide: true},
            ],
        }
    },
    computed: {
        selectedName(vm = this) {
            const opt = vm.profileOptions.find(p => p.value === vm.profile)
            return opt ? opt.name : ''
        }
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        showConfirmSelect() {
            const vm = this;
            vm.$refs.confirm.show()
        },
        async onSelected() {
            const vm = this
            vm.loadingSelect = true

            try {
                const userRef = await db.collection('users').doc(vm.currentUser.uid).get()
                const currentType = userRef.data()?.accountType || null

                if (!currentType) {
                    await db.collection('users').doc(vm.currentUser.uid).set({
                        accountType: vm.profile,
                    }, { merge: true })
                }

                await vm.bindUserAccount(vm.currentUser)
                vm.$emit('success')
            } catch (e) {
                vm.toast(vm.$t('common.an_error_has_occurred'), 'error')
            } finally {
                vm.loadingSelect = false
            }
        }
    },
}
</script>

<style scoped>

.select-profile-wrap {
    width: 100%;
    max-width: 380px;
}

.select-title {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-bottom: 24px;
}

.rol-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 100%;
    padding: 20px 12px;
    border-radius: 12px;
    border: 1.5px solid var(--v-outline-base);
    background: var(--v-surface-base);
    font-family: inherit;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
    appearance: none;
    transition: border-color .15s ease, background-color .15s ease;
}

.rol-card--wide {
    flex-direction: row;
    padding: 14px 12px;
}

.rol-card--selected {
    background: var(--v-secondary-base);
    border-color: var(--v-secondary-base);
}

.rol-card-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
}

.rol-card--selected .rol-card-label {
    color: #fff;
}

.confirm-role-text {
    font-size: 14px;
    color: var(--v-txtSecondary-base);
    line-height: 1.6;
    margin: 0;
}

.confirm-role-name {
    display: block;
    font-size: 22px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--v-secondary-base);
    margin: 8px 0 4px;
}

</style>
